import { useEffect, useState } from "react";
import { getAllCategory } from "../../../../Admin/helper";
import LoggedInNavbar from "../../../../Admin/helper/loggedInNavbar";
import { isAuthenticated } from "../../../../Auth/helper";
import { uploadmediafile } from "../../../index";
import { useNavigate } from "react-router-dom";

const AddImages = () => {
  let [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [uploadmedia, setupload] = useState({
    productName: "",
    categoryId: "0",
    subCategoryId: "0",
    description: null,
  });

  const [subCatgory, setSubCategory] = useState([]);
  const [uploadafile, setuploadfile] = useState(null);
  const [uploadThumbNailfile, setuploadThumbNailfile] = useState(null);

  const { productName, categoryId, description, subCategoryId } = uploadmedia;

  const [getallcat, setallcat] = useState([]);

  useEffect(() => {
    let currentdetails = isAuthenticated();

    const getcat = async () => {
      await getAllCategory(currentdetails.user._id, currentdetails.token)
        .then((re) => {
          console.log(re);
          setallcat(re.allCategory);
          setSubCategory(re.allsubCategory);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    getcat();
  }, []);

  function changeState() {
    setLoading(!loading);
    console.log(loading);
    setupload({ uploadmedia: "", productName: "", categoryId: "" });
    setuploadfile(0);
  }

  const handlesubmit = async (e) => {
    e.preventDefault();

    if (!productName || !categoryId || !subCategoryId || !uploadmedia) {
      alert("All fields are mandatory");
      return false;
    } else {
      setLoading(!loading);
      var newform = new FormData();

      newform.append("myfile", uploadafile);
      newform.append("myfile1", uploadThumbNailfile || null);
      newform.append("productName", productName);
      newform.append("categoryId", categoryId);
      newform.append("subCategoryId", subCategoryId);
      newform.append("description", description || null);

      let cur = isAuthenticated();

      await uploadmediafile(cur.user._id, cur.token, categoryId, newform)
        .then((ret) => {
          if (ret.message) {
            setLoading(false);
            alert(ret.message);
            setupload({
              productName: "",
              categoryId: "0",
              subCategoryId: "0",
              description: "",
            });
            setuploadfile(null);
            setuploadThumbNailfile(null);
          }
          if (ret.error) {
            setLoading(!loading);
            alert("Error in processing request");
            return false;
          }
        })
        .catch((e) => {
          setLoading(!loading);
          alert("Error in sending request");
          return false;
        });
    }
  };

  const handleformfield = (name) => (e) => {
    console.log(name, e.target.value);
    setupload({ ...uploadmedia, [name]: e.target.value });
  };

  const cardStyle = {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    marginBottom: "20px",
  };

  const headerStyle = {
    backgroundColor: "#f8f9fa",
    color: "#2c3e50",
    borderBottom: "2px solid #e9ecef",
    padding: "16px 20px",
    borderRadius: "12px 12px 0 0",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const backButtonStyle = {
    backgroundColor: "#6c757d",
    color: "#ffffff",
    border: "none",
    borderRadius: "6px",
    padding: "8px 16px",
    fontSize: "14px",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };

  const formGroupStyle = {
    marginBottom: "20px",
  };

  const labelStyle = {
    display: "block",
    marginBottom: "8px",
    fontWeight: "500",
    color: "#495057",
    fontSize: "14px",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    fontSize: "14px",
    backgroundColor: "#ffffff",
    transition: "border-color 0.3s ease, box-shadow 0.3s ease",
    boxSizing: "border-box",
  };

  const selectStyle = {
    ...inputStyle,
    cursor: "pointer",
  };

  const textareaStyle = {
    ...inputStyle,
    resize: "vertical",
    minHeight: "100px",
  };

  const fileInputStyle = {
    ...inputStyle,
    padding: "8px 16px",
  };

  const buttonStyle = {
    backgroundColor: "#ffc107",
    color: "#212529",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "16px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  };

  const loadingButtonStyle = {
    ...buttonStyle,
    backgroundColor: "#6c757d",
    cursor: "not-allowed",
  };

  return (
    <>
      <LoggedInNavbar />
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
        }}
      >
        <div className="container">
          <div style={cardStyle}>
            <div style={headerStyle}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <i className="fas fa-image me-2"></i>
                Upload Images
              </div>
              <button
                style={backButtonStyle}
                onClick={() => navigate("/adminDashboard")}
                title="Back to Dashboard"
              >
                <i className="fas fa-arrow-left"></i>
                Back
              </button>
            </div>
            <div style={{ padding: "24px" }}>
              <form onSubmit={handlesubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-file-image me-2"></i>
                        Select Image File
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="myfile"
                        onChange={(e) => setuploadfile(e.target.files[0])}
                        accept="image/*"
                        style={fileInputStyle}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-image me-2"></i>
                        Select Thumbnail
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        name="myfile1"
                        accept="image/*"
                        onChange={(e) =>
                          setuploadThumbNailfile(e.target.files[0])
                        }
                        style={fileInputStyle}
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-tag me-2"></i>
                        Media Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        name="productName"
                        value={productName}
                        onChange={handleformfield("productName")}
                        placeholder="Enter image name"
                        style={inputStyle}
                        required
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-list me-2"></i>
                        Media Type
                      </label>
                      <select
                        className="form-select"
                        value={categoryId}
                        onChange={handleformfield("categoryId")}
                        style={selectStyle}
                        required
                      >
                        <option value="0">Select Media type</option>
                        {getallcat.map((i, key) => {
                          return (
                            <option key={i._id} value={i._id}>
                              {i.categoryName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-layer-group me-2"></i>
                        Media Sub Type
                      </label>
                      <select
                        className="form-select"
                        value={subCategoryId}
                        onChange={handleformfield("subCategoryId")}
                        style={selectStyle}
                        required
                      >
                        <option value="0">Select Media Sub type</option>
                        {subCatgory.map((i, key) => {
                          return (
                            <option key={i._id} value={i._id}>
                              {i.subCategoryName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div style={formGroupStyle}>
                      <label style={labelStyle}>
                        <i className="fas fa-align-left me-2"></i>
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        rows="3"
                        value={description || ""}
                        name="description"
                        onChange={handleformfield("description")}
                        placeholder="Enter image description"
                        style={textareaStyle}
                      ></textarea>
                    </div>
                  </div>
                </div>

                <div style={{ marginTop: "24px", textAlign: "center" }}>
                  <button
                    className="btn"
                    disabled={loading}
                    type="submit"
                    style={loading ? loadingButtonStyle : buttonStyle}
                  >
                    {loading ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i>
                        Uploading Image...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-upload"></i>
                        Upload Image
                      </>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddImages;
